/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Icon } from '../../../ui/Icon';
import Card from '../Cards';

// import Swiper core and required modules
// import Swiper from 'swiper';

// import 'swiper/swiper-bundle.css';
import * as styles from './index.styles';

export default class Slider extends SafePureComponent {
  myRef = React.createRef();
  isNextPrevTriggered = false;
  swiper = node => (this.swiper = node && node.swiper);
  state = {};

  renderCards() {
    const { cards } = this.props;

    return cards.map((data, index) => {
      return (
        <React.Fragment key={index}>
          <Card data={data} />
        </React.Fragment>
      );
    });
  }

  goPrev = () => {
    this.isNextPrevTriggered = true;
    const {
      current: { swiper },
    } = this.myRef;
    if (swiper) {
      swiper.autoplay.stop();
      let prevIndex = swiper.realIndex - 1;

      if (swiper.realIndex === swiper.loopedSlides - 1) {
        let translate = swiper.translate;
        this.nextTranslate =
          translate +
          (swiper.slidesSizesGrid[0] + swiper.passedParams.spaceBetween);
        this.setWrapperTrans(300, this.nextTranslate);
        setTimeout(() => {
          swiper.slideToLoop(prevIndex, 0);
          swiper.update();
        }, 310);
      } else {
        swiper.slideToLoop(prevIndex, 300);
      }
    }
  };

  goNext = () => {
    this.isNextPrevTriggered = true;
    const {
      current: { swiper },
    } = this.myRef;
    if (swiper) {
      swiper.autoplay.stop();

      let nextIndex = swiper.realIndex + 1;

      if (swiper.realIndex) {
        swiper.slideToLoop(nextIndex, 300);
      } else {
        let translate = swiper.translate;
        this.nextTranslate =
          translate -
          (swiper.slidesSizesGrid[0] + swiper.passedParams.spaceBetween);
        this.setWrapperTrans(300, this.nextTranslate);
        setTimeout(() => {
          swiper.slideToLoop(nextIndex, 0);
          swiper.update();
        }, 310);
      }
    }
  };

  nextTranslate = 0;
  currentTranslate = 0;
  onMouseEnter = () => {
    const {
      current: { swiper },
    } = this.myRef;

    this.isNextPrevTriggered = false;
    if (swiper) {
      this.nextTranslate = swiper.translate;
      this.currentTranslate = swiper.getTranslate();

      swiper.autoplay.stop();
      this.setWrapperTrans(0, this.currentTranslate);
    }
  };

  onMouseLeave = () => {
    const {
      current: { swiper },
    } = this.myRef;
    if (swiper) {
      swiper.update();
      if (this.isNextPrevTriggered === false) {
        let diffTranslate =
          parseInt(this.nextTranslate, 10) -
          parseInt(this.currentTranslate, 10);

        let calcTime =
          (diffTranslate * swiper.passedParams.speed) /
          (swiper.slidesSizesGrid[0] + swiper.passedParams.spaceBetween);

        if (calcTime === 0) {
          calcTime = 300;
        }
        this.setWrapperTrans(calcTime, this.nextTranslate - 1);
      }
      swiper.autoplay.start();
    }
  };

  setWrapperTrans = (transitionDuration, translate3d) => {
    const { swiper } = this.myRef.current;
    if (swiper) {
      swiper.$wrapperEl[0].style.transitionDuration =
        Math.abs(transitionDuration) + 'ms';
      swiper.$wrapperEl[0].style.transform =
        'translate3d(' + translate3d + 'px, 0px, 0px)';
    }
  };

  safeRender() {
    const { speed, delay } = this.props;
    const swiperParams = {
      initialSlide: 0,
      loop: true,
      loopFillGroupWithBlank: false,

      freeMode: true,

      spaceBetween: 32,
      slidesPerView: 'auto',
      grabCursor: true,
      speed: parseInt(speed, 10),
      autoplay: {
        delay: parseInt(delay, 10),
        disableOnInteraction: false,
      },
      breakpoints: {
        // when window width is >= 640px

        375: {
          spaceBetween: 24,
        },
        768: {
          spaceBetween: 32,
        },

        1024: {
          spaceBetween: 24,
        },
        1440: {
          spaceBetween: 32,
        },
      },
    };
    return (
      <div
        css={[styles.homepageSlide]}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        aria-hidden="true"
      >
        <Swiper ref={this.myRef} {...swiperParams}>
          {this.renderCards()}
        </Swiper>

        <button className="regus-button-prev" onClick={this.goPrev}>
          <Icon name="arrow-left" />
        </button>

        <button className="regus-button-next" onClick={this.goNext}>
          <Icon name="arrow-right" />
        </button>
      </div>
    );
  }
}
